module.exports = __webpack_public_path__ + "static/img/account_icon2.8fadba9d.png";